import { render, staticRenderFns } from "./cloneChart.vue?vue&type=template&id=282fa35f&scoped=true"
import script from "./cloneChart.vue?vue&type=script&lang=js"
export * from "./cloneChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fa35f",
  null
  
)

export default component.exports